module.exports = __webpack_public_path__ + "img/PAYMENT.376abcf8.svg";